import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
import { FlexTable } from 'src/components/shared/flexTables'
// import { waterfallMock } from 'src/components/charts-simulation/waterfallMock'

const state = {
  [NameSpace.BAR_CHART]: {
    chart: null,
    error: null
  },
  [NameSpace.LIFT_SIMULATION]: {
    graphFilterMap: null,
    headers: [],
    originalTableHeader: null,
    data: [],
    error: null
  },
  [NameSpace.WATERFALL_DATA]: {
    data: {
      graphData: null,
      labels: null,
      colors: null
    },
    error: null
  },
  [NameSpace.CALCULATION_FIELDS]: {
    data: null,
    error: null
  },
  [NameSpace.SIMULATION_CHANGES]: {
    isSuccess: false
  }
}

const toolTipStyle = 'style="width: 150px; padding: 5px; font-size: 1.2rem;"'

const getters = {
  [NameSpace.GET_CALCULATION_FIELDS]: state => {
    return state[NameSpace.CALCULATION_FIELDS]
  },
  [NameSpace.GET_SIMULATION_CHANGES]: state => {
    return state[NameSpace.SIMULATION_CHANGES]
  },
  [NameSpace.GET_BAR_CHART]: state => {
    return transform(state[NameSpace.BAR_CHART])
  },
  [NameSpace.GET_BAR_CHART_LEGENDS]: state => {
    let stateObj = state[NameSpace.BAR_CHART]
    if (stateObj.chart) {
      const { header } = stateObj.chart
      return header
    } else {
      return []
    }
  },
  [NameSpace.GET_LIFT_SIMULATION]: state => {
    return state[NameSpace.LIFT_SIMULATION]
  },
  [NameSpace.GET_LINE_CHART_RADIO]: state => {
    let graphRadio = state[NameSpace.LIFT_SIMULATION].graphFilterMap
    if (graphRadio) {
      return graphRadio
    }
    return null
  },
  [NameSpace.GET_WATERFALL_DATA]: state => {
    return state[NameSpace.WATERFALL_DATA]
  }
}

const mutations = {
  [NameSpace.MUTATE_BAR_CHART]: (state, payload) => {
    state[NameSpace.BAR_CHART] = payload
  },
  [NameSpace.MUTATE_LIFT_SIMULATION]: (state, payload) => {
    state[NameSpace.LIFT_SIMULATION] = payload
  },
  [NameSpace.MUTATE_WATERFALL_DATA]: (state, payload) => {
    state[NameSpace.WATERFALL_DATA] = payload
  },
  [NameSpace.MUTATE_CALCULATION_FIELDS]: (state, payload) => {
    state[NameSpace.CALCULATION_FIELDS] = payload
  },
  [NameSpace.MUTATE_SIMULATION_CHANGES]: (state, payload) => {
    state[NameSpace.SIMULATION_CHANGES] = payload
  }
}

const actions = {
  [NameSpace.FETCH_CALCULATION_FIELDS]: ({ commit }, payload) => {
    ParseService.refreshLiftChanges(payload)
      .then(data => {
        console.log(data)
        if (data) {
          commit(NameSpace.MUTATE_CALCULATION_FIELDS, {
            data: data,
            error: null
          })
        }
      })
      .catch(error => {
        console.log('In chart js:', error)
        commit(NameSpace.MUTATE_CALCULATION_FIELDS, {
          data: null,
          error: error
        })
      })
  },
  [NameSpace.FETCH_BAR_CHART]: ({ commit }, payload) => {
    ParseService.getGraphData(payload)
      .then(data => {
        if (data) {
          commit(NameSpace.MUTATE_BAR_CHART, {
            chart: data,
            error: null
          })
        } else {
          commit(NameSpace.MUTATE_BAR_CHART, {
            chart: null,
            error: null
          })
        }
      })
      .catch(error => {
        console.log('In chart js:', error)
        commit(NameSpace.MUTATE_BAR_CHART, {
          chart: null,
          error: error
        })
      })
  },
  [NameSpace.FETCH_LIFT_SIMULATION]: ({ commit }, payload) => {
    resetGetLiftSimulationData(commit)
    ParseService.getLiftSimulation(payload)
      .then(simulate => {
        if (simulate) {
          const { header, data } = simulate
          let tableInstance = new FlexTable(header, data, 1)
          let tableHeaders = tableInstance.getObjectTableHeaders(header)

          commit(NameSpace.MUTATE_LIFT_SIMULATION, {
            graphFilterMap: data.graphFilterMap,
            headers: tableHeaders,
            originalTableHeader: header,
            data: data,
            error: null
          })
        } else {
          commit(NameSpace.MUTATE_LIFT_SIMULATION, {
            graphFilterMap: null,
            headers: [],
            originalTableHeader: null,
            data: [],
            error: null
          })
        }
      })
      .catch(error => {
        console.log('In FETCH_LIFT_SIMULATION:', error)
        commit(NameSpace.MUTATE_LIFT_SIMULATION, {
          graphFilterMap: null,
          headers: [],
          originalTableHeader: null,
          data: [],
          error: error
        })
      })
  },
  [NameSpace.FETCH_WATERFALL_DATA]: ({ commit }, payload) => {
    resetWaterfallData(commit)
    ParseService.getWaterFallData(payload)
      .then(waterfall => {
        if (waterfall) {
          const { graphData, labels, colors } = waterfall

          commit(NameSpace.MUTATE_WATERFALL_DATA, {
            data: {
              graphData,
              labels,
              colors
            },
            error: null
          })
        } else {
          commit(NameSpace.MUTATE_WATERFALL_DATA, {
            data: {
              graphData: null,
              labels: null,
              colors: null
            },
            error: 'No Data Found'
          })
        }
      })
      .catch(error => {
        console.log('In FETCH WATERFALL DATA:', error)
        commit(NameSpace.MUTATE_WATERFALL_DATA, {
          data: {
            graphData: null,
            labels: null,
            colors: null
          },
          error: error
        })
      })
  },
  [NameSpace.POST_SIMULATION_CHANGES]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SIMULATION_CHANGES, false)
    ParseService.applySimulationDecision(payload)
    .then(simulate => {
      if (simulate) {
        console.log(simulate)
        let hasWarning = false
        const { header, data } = simulate
        let tableInstance = new FlexTable(header, data, 1)
        let tableHeaders = tableInstance.getObjectTableHeaders(header)
        if (simulate.warnings && simulate.warnings.length) {
          hasWarning = true
        }
        if (hasWarning) {
          commit(NameSpace.MUTATE_LIFT_SIMULATION, {
            graphFilterMap: data.graphFilterMap,
            headers: tableHeaders,
            originalTableHeader: header,
            data: data,
            warnings: simulate.warnings,
            error: null
          })
        } else {
          commit(NameSpace.MUTATE_LIFT_SIMULATION, {
            graphFilterMap: data.graphFilterMap,
            headers: tableHeaders,
            originalTableHeader: header,
            data: data,
            error: null
          })
        }
        commit(NameSpace.MUTATE_SIMULATION_CHANGES, {isSuccess: true})
      } else {
        commit(NameSpace.MUTATE_LIFT_SIMULATION, {
          graphFilterMap: null,
          headers: [],
          originalTableHeader: null,
          data: [],
          error: null
        })
      }
    })
    .catch(error => {
      console.log('In FETCH_LIFT_SIMULATION:', error)
      commit(NameSpace.MUTATE_LIFT_SIMULATION, {
        graphFilterMap: null,
        headers: [],
        originalTableHeader: null,
        data: [],
        error: error
      })
    })
  }
}

function resetGetLiftSimulationData (commit) {
  commit(NameSpace.MUTATE_LIFT_SIMULATION, {
    graphFilterMap: null,
    headers: [],
    originalTableHeader: null,
    data: [],
    error: null
  })
}

function resetWaterfallData (commit) {
  commit(NameSpace.MUTATE_WATERFALL_DATA, {
    data: {
      graphData: null,
      labels: null,
      colors: null
    },
    error: null
  })
}

function transform (data) {
  if (data) {
    const { chart } = data
    if (chart && chart.header && chart.graphData) {
      let header = chart.header
      let graphData = chart.graphData
      return graphData.map((obj) => {
        let inColor = obj.colorCode
        let outColor = (header[inColor.toString()]).color
        let annotate = ''
        if (obj.quantity_per_week >= 0) {
          annotate = obj.quantity_per_week
        }
        return [obj.date, obj.quantity_per_week, outColor, annotate.toString(), getToolTipData(obj, chart.labels, chart.onHover)]
      })
    }
  }
}

function getToolTipData (obj, labels, onHover) {
  let finalToolTip = ''
  onHover.map((item) => {
    finalToolTip = finalToolTip.concat(`<div ${toolTipStyle}>${labels[item]} : ${!obj[item] ? 'N/A' : obj[item]}</div>`)
    return finalToolTip
  })
  return finalToolTip
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/chart.js